/* @flow */
// typecheck: ignore file
import React from 'react';
import ReactSelect from 'react-select';

import './styles/Select.scss';

type Option = {
  label: ?any,
  value: ?any,
};

class Select extends React.Component {
  props: {
    className?: ?string,
    clearable?: ?boolean,
    onChange?: Function,
    options: Option[],
    placeholder?: ?string,
    value?: ?any,
    required?: boolean,
    name?: string,
    autoComplete?: string,
    searchable?: boolean,
    inputProps?: ?any,
    onInputKeyUp?: Function,
  };

  static defaultProps = {
    clearable: false,
    options: [],
  };

  _select = null;

  focus = () => {
    if (this._select) {
      this._select.focus();
    }
  };

  onInputKeyUp = () => {
    if (!this._select) {
      return;
    }

    const inputText = this._select.getInputValue();
    const selected = this.props.options.find(option => {
      let optionLabel;
      let inputLabel;
      if (option.label) {
        optionLabel = String(option.label).toLowerCase();
      }
      if (inputText) {
        inputLabel = String(inputText).toLowerCase();
      }
      return inputLabel === optionLabel;
    });
    if (this.props.onInputKeyUp) {
      this.props.onInputKeyUp(selected);
    }
  };

  // $FlowIssue
  onChange = (option) => {
    if (this.props.onChange) {
      this.props.onChange(option.value);
    }
  };

  render() {
    const {
      className,
      clearable,
      options,
      placeholder,
      value,
      required,
      name,
      autoComplete,
      searchable,
    } = this.props;

    for (const option of options) {
      option.value = String(option.value);
    }

    const inputProps = Object.assign(
      {},
      this.props.inputProps,
      { onKeyUp: this.onInputKeyUp }
    );

    return (
      <ReactSelect
        ref={c => (this._select = c)}
        className={className}
        clearable={clearable}
        onChange={this.onChange}
        options={options}
        placeholder={placeholder}
        value={value && String(value)}
        required={required}
        name={name}
        autoComplete={autoComplete}
        inputProps={inputProps}
        searchable={searchable}
      />
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.jsx